import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormField, FormItem } from '@/components/ui/form';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

const InputToggleGroup = ({
  name,
  className,
  options = '',
  isRequired = false,
  isDisabled = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });

  const validationRules = {};

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={` ${className}`}>
      <FormField
        name={name}
        key={name}
        control={control}
        defaultValue={false}
        rules={validationRules}
        render={({ field }) => (
          <FormItem className='tw-flex tw-flex-col'>
            <FormControl>
              <ToggleGroup
                type='single'
                size='sm'
                disabled={isDisabled}
                value={field.value}
                onValueChange={(value) => {
                  if (value) {
                    field.onChange(value || null);
                  }
                }}
                className='tw-gap-2'
              >
                {options.map((o) => (
                  <ToggleGroupItem
                    key={o.value}
                    value={o.value}
                    title={o.label}
                    disabled={o.disabled}
                  >
                    {o.component}
                  </ToggleGroupItem>
                ))}
              </ToggleGroup>
            </FormControl>
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputToggleGroup;
